var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBattery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 12,
    viewBox: "0 0 19 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0447 11.7231H2.14924C0.964424 11.7231 0 10.7595 0 9.5739V2.14924C0 0.963643 0.964424 0 2.14924 0H15.0447C16.2295 0 17.1939 0.963643 17.1939 2.14924V2.34463H17.3823C18.1365 2.34463 18.75 2.95814 18.75 3.71233V8.01082C18.75 8.76501 18.1365 9.37852 17.3823 9.37852H17.1939V9.5739C17.1939 10.7595 16.2295 11.7231 15.0447 11.7231ZM2.14924 1.17231C1.61076 1.17231 1.17231 1.61076 1.17231 2.14924V9.5739C1.17231 10.1124 1.61076 10.5508 2.14924 10.5508H15.0447C15.5832 10.5508 16.0216 10.1124 16.0216 9.5739V8.79236C16.0216 8.4688 16.2842 8.2062 16.6078 8.2062H17.3823C17.4902 8.2062 17.5777 8.11867 17.5777 8.01082V3.71233C17.5777 3.60448 17.4902 3.51694 17.3823 3.51694H16.6078C16.2842 3.51694 16.0216 3.25435 16.0216 2.93079V2.14924C16.0216 1.61076 15.5832 1.17231 15.0447 1.17231H2.14924Z",
    fill: "#A4A4A4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.78879 10.6246C1.46524 10.6246 0.875 10.4482 0.875 10.1246L0.875 1.21077C0.875 0.887216 2.05144 0.125 2.375 0.125C2.375 0.625 17.4612 -0.874022 16.9612 2.625L17.875 4.125V8.125L15.875 10.6246L13.875 11.1246C13.375 11.1246 2.11235 10.6246 1.78879 10.6246Z",
    fill: "#A4A4A4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBattery);
export default __webpack_public_path__ + "static/media/battery.113750b5.svg";
export { ForwardRef as ReactComponent };